module.exports = __webpack_public_path__ + "static/media/Codebadge.b9bf5e02.png";